var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition',{attrs:{"mode":"out-in","name":"fade-grow"}},[(_vm.showPrompt)?_c('div',{staticClass:"sign-up-prompt"},[_vm._v("Yo dawg, you should sign up so your work is saved.")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }